import React, { createContext } from 'react';
import {
  Store, StarO, Delivery, Location, Clock, Dollar,
} from 'components/icons';

export const SortByTypes = {
  PICKED_FOR_YOU: 'PICKED_FOR_YOU',
  NEAR_ME: 'NEAR_ME',
  NEW_MERCHANT: 'NEW_MERCHANT',
  MOST_POPULAR: 'MOST_POPULAR',
  DELIVERY_FEE: 'DELIVERY_FEE',
  TIME_TO_DELIVERY: 'TIME_TO_DELIVERY',
  ECONOMY: 'ECONOMY',
};

export const SortByTypesOptions = {
  [SortByTypes.NEAR_ME]: {
    title: 'Near Me',
    icon: <Location />,
    slug: 'distance',
  },
  [SortByTypes.NEW_MERCHANT]: {
    title: 'New Merchant',
    icon: <Store />,
    slug: '-created_at',
  },
  [SortByTypes.MOST_POPULAR]: {
    title: 'Most Popular',
    icon: <StarO />,
    slug: 'popularity',
  },
  [SortByTypes.DELIVERY_FEE]: {
    title: 'Delivery Fee',
    icon: <Delivery />,
    slug: 'delivery_fee',
  },
  [SortByTypes.TIME_TO_DELIVERY]: {
    title: 'Delivery Time',
    icon: <Clock />,
    slug: 'time_to_delivery',
  },
  [SortByTypes.ECONOMY]: {
    title: 'Economy',
    icon: <Dollar />,
    slug: 'price_class',
  },
};
